// Tabelle im Formular (Prototyp CSV-Vorschau): dunkle Innenfläche, Kopfzeile in Großbuchstaben.
// Breite Tabellen scrollen in ihrer Karte waagerecht – die Pille selbst nie.
import type { ReactNode } from 'react';
import { CHIP, INNEN, type ChipFarbe } from './form-stil';

export interface FormTabellenZeile {
  key: string | number;
  zellen: ReactNode[];
  /** Ausgeschlossene Zeile blass darstellen */
  gedimmt?: boolean;
}

export function FormTabelle({ spalten, zeilen, farbe, beschriftung }: {
  spalten: readonly string[];
  zeilen: readonly FormTabellenZeile[];
  /** Farbe der Kopfzeile */
  farbe?: ChipFarbe;
  /** Screenreader-Bezeichnung der Tabelle */
  beschriftung: string;
}) {
  return (
    <div className="pf-scroll overflow-x-auto" style={{ borderRadius: 16, background: INNEN.flaeche, boxShadow: INNEN.ring }}>
      <table aria-label={beschriftung} className="w-full" style={{ borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ background: farbe ? CHIP[farbe].flaeche : INNEN.kopf }}>
            {spalten.map((s, i) => (
              <th key={i} scope="col" className="whitespace-nowrap text-left" style={{
                padding: '9px 12px', fontSize: 10.5, fontWeight: 800, letterSpacing: '0.05em', textTransform: 'uppercase',
                color: farbe ? CHIP[farbe].text : 'rgba(255,255,255,0.4)',
              }}>{s}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {zeilen.map(z => (
            <tr key={z.key} style={{ borderTop: `0.5px solid ${INNEN.linie}`, opacity: z.gedimmt ? 0.4 : 1, transition: 'opacity .2s' }}>
              {z.zellen.map((c, i) => (
                <td key={i} className="whitespace-nowrap" style={{ padding: '8px 12px', fontSize: 12.5, fontWeight: 600, maxWidth: 220, overflow: 'hidden', textOverflow: 'ellipsis' }}>{c}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
